import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { AccountingHeading } from 'src/features/accountingHeaders/utils/types';
import { AccountingHeadingFormSchemaValues } from 'src/features/accountingHeaders/utils/formSchema';

const RESOURCE = '/financial-documents/accounting-heading/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: AccountingHeadingFormSchemaValues): Promise<AccountingHeading> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateAccountingHeader };
